var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loaded)?_c(_vm.curView,{tag:"component"}):_vm._e(),(!_vm.loaded)?_c('div',{staticClass:"center vertical-middle loading"},[_vm._v("\n\t\t\tLoading ...\n\t\t")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }